import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";

const InstructionsPanel = () => {
  const theme = useTheme();

  const getCardStyles = () => {
    return {
      height: "100%",
      boxShadow: "none",
      borderRadius: "6px",
      backgroundColor: alpha(theme.palette.grey.A200, 0.05),
      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    };
  };

  const getCardContentStyles = () => {
    return {
      p: 3,
    };
  };

  const getTitleStyles = () => {
    return {
      fontWeight: 600,
      color: theme.palette.primary.main,
      mb: 3,
      textAlign: "center",
    };
  };

  const getInstructionsContainerStyles = () => {
    return {
      display: "flex",
      flexDirection: "column",
      gap: 2,
    };
  };

  const getInstructionItemStyles = () => {
    return {
      display: "flex",
      alignItems: "flex-start",
      gap: 1,
    };
  };

  const getInstructionNumberStyles = () => {
    return {
      minWidth: "20px",
      fontWeight: 600,
      color: theme.palette.primary.main,
    };
  };

  const getInstructionTextStyles = () => {
    return {
      lineHeight: 1.6,
    };
  };

  const getWarningTextStyles = () => {
    return {
      lineHeight: 1.6,
      color: "warning",
    };
  };

  const createInstructionItem = (number, text, isWarning = false) => {
    const textStyles = isWarning
      ? getWarningTextStyles()
      : getInstructionTextStyles();
    const color = isWarning ? "warning" : "text.primary";

    return (
      <Box key={number} sx={getInstructionItemStyles()}>
        <Typography variant="body2" sx={getInstructionNumberStyles()}>
          {number}.
        </Typography>
        <Typography variant="body2" color={color} sx={textStyles}>
          {text}
        </Typography>
      </Box>
    );
  };

  const getInstructions = () => {
    return [
      {
        number: "*",
        text: "Caso o botão 'Ativar iFood' não esteja aparecendo, experimente alternar entre sites no seu navegador, abra uma aba nova e volte para o Slapie",
        isWarning: true,
      },
      {
        number: "*",
        text: "Ou você pode clicar no botão azul com o símbolo de + no canto inferior esquerdo e depois clicar no botão do chat ifood",
        isWarning: true,
      },
      {
        number: "1",
        text: "Para ativar o chat iFood clique em 'Ativar iFood' aqui em baixo no canto direito, ou clique no botão vermelho com um sinal de + no centro",
      },
      {
        number: "2",
        text: "Depois disso, o chat vai abrir ou vai pedir permissão",
      },
      {
        number: "3",
        text: "Caso peça permissão você clica no botão disponível e o portal iFood vai abrir",
      },
      {
        number: "4",
        text: "Lá você dá permissão e volta para o Slapie",
      },
      {
        number: "5",
        text: "Caso não peça permissão então você já pode usar",
      },
      {
        number: "6",
        text: "Dentro da janela iFood, no canto superior direito (em cima na direita da janela iFood)",
      },
      {
        number: "7",
        text: "Você clica no botão de tela cheia (ícone com uma seta na diagonal)",
      },
      {
        number: "8",
        text: "Agora sim, pode usar o Slapie e chat iFood",
      },
    ];
  };

  const renderInstructions = () => {
    const instructions = getInstructions();

    return instructions.map((instruction) =>
      createInstructionItem(
        instruction.number,
        instruction.text,
        instruction.isWarning
      )
    );
  };

  return (
    <Box sx={{ p: 2, maxHeight: "100vh", overflow: "auto" }}>
      <Card sx={getCardStyles()}>
        <CardContent sx={getCardContentStyles()}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={getTitleStyles()}
          >
            Como Ativar o Chat iFood
          </Typography>

          <Box sx={getInstructionsContainerStyles()}>
            {renderInstructions()}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InstructionsPanel;
